import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { RequestCategoryType, RequestSubCategoryType } from 'src/app/request-v2/models/request.model';
import { RequestsV2ImplService } from 'src/app/request-v2/services/requests-v2.impl.service';

@Component({
    selector: 'app-category-select',
    templateUrl: './category-select.component.html',
    styleUrls: ['./category-select.component.scss'],
})
export class CategorySelectComponent {
    @Input() categories: RequestCategoryType[] = [];
    @Input() selectedCategory: RequestCategoryType | null = null;
    @Input() requestId: string;
    @Input() readOnly: boolean = true;
    @Input() subjectSelectRef: ElementRef;

    @Output() categoryChange = new EventEmitter<RequestCategoryType>();
    @Output() openSubjectMenu = new EventEmitter<RequestCategoryType>();
    @Output() categoryAndSubjectChange = new EventEmitter<{ category: RequestCategoryType; subject: RequestSubCategoryType }>();
    @Output() revertChanges = new EventEmitter<void>();

    tempSelectedCategory: RequestCategoryType | null = null;
    isAwaitingSubjectSelection: boolean = false;

    constructor(private requestsService: RequestsV2ImplService) {}

    onCategorySelect(categoryId: string): void {
        if (this.readOnly) return;

        const foundCategory = this.categories?.find((c) => c._id === categoryId);
        if (!foundCategory) return;

        // Store the temporary selection
        this.tempSelectedCategory = foundCategory;

        // Signal to open the subject select dropdown
        this.openSubjectMenu.emit(foundCategory);
        this.isAwaitingSubjectSelection = true;
    }

    confirmCategoryChange(subCategory: RequestSubCategoryType): void {
        if (!this.tempSelectedCategory || !this.isAwaitingSubjectSelection) return;

        // Now that we have both category and subject, we can update
        const category = this.tempSelectedCategory;

        // If we have a requestId, call the API to update both
        if (this.requestId) {
            this.requestsService.updateRequestCategoryAndSubject(this.requestId, category._id, subCategory._id).subscribe(
                (updatedRequest) => {
                    // Only update local state and emit events after successful API call
                    this.selectedCategory = category;

                    // Emit combined change event on success
                    this.categoryAndSubjectChange.emit({
                        category: category,
                        subject: subCategory,
                    });
                },
                (error) => {
                    // Emit event to revert changes in parent component
                    this.revertChanges.emit();
                },
            );
        } else {
            // For cases without API call (when not given a requestId)
            this.selectedCategory = category;
            this.categoryAndSubjectChange.emit({
                category: category,
                subject: subCategory,
            });
        }

        // Always reset the temporary state
        this.tempSelectedCategory = null;
        this.isAwaitingSubjectSelection = false;
    }

    cancelCategoryChange(): void {
        // Reset the temp selection if subject selection was cancelled
        this.tempSelectedCategory = null;
        this.isAwaitingSubjectSelection = false;
    }
}
